export enum ROLES {
  ADMIN = "admin",
  GROUP_ADMIN = "group",
}

export interface IGroup {
  group_id?: string;
  name?: string;
  status?: string;
}
export class GroupDTO implements IGroup {
  group_id? = null;
  name? = null;
  status? = null;
}
export interface IUser {
  id?: string;
  name?: string;
  email?: string;
  password?: string;
  groups?: Array<GroupDTO>;
  created?: any;
  group_id?: string;
}

export class UserDTO implements IUser {
  id?: string;
  name? = null;
  email? = null;
  password? = null;
  groups?: Array<GroupDTO>;
  created? = null;
  group_id? = null;
}

export default class User extends UserDTO {
  original = {};
  constructor(dto?: UserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      // dto.customer && (dto.customer = new Customer(dto.customer));
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: null,
      email: null,
      password: null,
      group_id: null,
      groups: [],
    });
  }
}
